import type { IMonitorReplay, IReplayEvent } from '@interfaces/IMonitorApi';

// GENERATED from a real site day (local simulation site, 2026-10-19) — the replay
// track's skeleton draws it in grey while the first day loads. Times are minutes
// from the day’s start; no ids, names or floors.

/** [minute, workers] — one frame per 2 minutes. */
const FRAMES: [number, number][] = [
  [25, 16], [88, 15], [99, 12], [116, 11], [139, 17], [139, 11], [140, 13], [142, 14], [144, 17], [146, 15],
  [148, 15], [150, 17], [152, 14], [154, 14], [156, 14], [158, 13], [160, 15], [162, 19], [164, 15], [166, 14],
  [168, 16], [170, 17], [172, 11], [174, 12], [176, 18], [178, 15], [180, 16], [182, 18], [184, 14], [186, 14],
  [188, 15], [190, 15], [192, 15], [194, 17], [196, 20], [198, 18], [200, 14], [202, 19], [204, 23], [206, 20],
  [208, 19], [210, 16], [212, 20], [214, 18], [216, 16], [218, 17], [220, 19], [222, 19], [224, 18], [226, 22],
  [228, 23], [230, 20], [232, 20], [234, 22], [236, 18], [238, 17], [240, 19], [242, 16], [244, 19], [246, 18],
  [248, 15], [250, 19], [252, 21], [254, 17], [256, 18], [258, 16], [260, 17], [262, 19], [264, 14], [266, 12],
  [268, 19], [270, 17], [272, 19], [274, 16], [276, 17], [278, 18], [280, 20], [282, 23], [284, 20], [286, 19],
  [288, 18], [290, 17], [292, 14], [294, 16], [296, 14], [298, 13], [300, 17], [302, 16], [304, 17], [306, 16],
  [308, 14], [310, 16], [312, 19], [314, 13], [316, 15], [318, 14], [320, 13], [322, 21], [324, 19], [326, 15],
  [328, 21], [330, 17], [332, 19], [334, 16], [336, 18], [338, 21], [340, 18], [342, 15], [344, 15], [346, 21],
  [348, 15], [350, 15], [352, 12], [354, 16], [356, 12], [358, 16], [360, 15], [362, 17], [364, 15], [366, 18],
  [368, 13], [370, 13], [372, 19], [374, 15], [376, 16], [378, 12], [380, 18], [382, 13], [384, 17], [386, 18],
  [388, 16], [390, 17], [392, 16], [394, 18], [396, 16], [398, 17], [400, 15], [402, 14], [404, 16], [406, 15],
  [408, 17], [410, 17], [412, 17], [414, 16], [416, 16], [418, 16], [420, 20], [422, 13], [424, 16], [426, 16],
  [428, 15], [430, 16], [432, 16], [434, 15], [436, 13], [438, 18], [440, 14], [442, 10], [444, 15], [446, 12],
  [448, 16], [450, 16], [452, 18], [454, 18], [456, 18], [458, 19], [460, 17], [462, 17], [464, 15], [466, 15],
  [468, 16], [470, 17], [472, 15], [474, 16], [476, 14], [478, 17], [480, 12], [482, 14], [484, 14], [486, 12],
  [488, 12], [490, 18], [492, 9], [494, 15], [496, 14], [498, 13], [500, 11], [502, 14], [504, 14], [506, 12],
  [508, 12], [510, 13], [512, 14], [514, 13], [516, 13], [518, 11], [520, 12], [522, 13], [524, 17], [526, 16],
  [528, 15], [530, 14], [532, 16], [534, 14], [536, 16], [538, 18], [540, 20], [542, 18], [544, 16], [546, 19],
  [548, 16], [550, 17], [553, 17], [553, 15], [554, 17], [556, 20], [558, 14], [560, 18], [562, 16], [564, 17],
  [566, 18], [568, 14], [570, 12], [572, 15], [574, 14], [576, 15], [578, 15], [580, 17], [582, 19], [584, 13],
  [586, 17], [588, 12], [590, 15], [592, 17], [594, 15], [596, 21], [598, 17], [600, 19], [602, 17], [604, 20],
  [606, 22], [608, 21], [610, 21], [612, 16], [614, 12], [616, 17], [618, 17], [620, 17], [622, 17], [624, 21],
  [626, 21], [628, 17], [630, 18], [632, 18], [634, 17], [636, 17], [638, 20], [642, 15], [713, 23], [756, 21],
  [822, 13], [904, 14], [1004, 3], [1090, 18], [1163, 12], [1244, 10], [1313, 21], [1398, 3]
];
/** From, to (minutes). */
const GAPS: [number, number][] = [
  [25, 88], [88, 99], [99, 116], [116, 139], [551, 553], [639, 642], [642, 713], [713, 756], [756, 822], [822,
  904], [904, 1004], [1004, 1090], [1090, 1163], [1163, 1244], [1244, 1313], [1313, 1398]
];
/** Kind (safety / issue / equipment / peak), minute, and a critical flag or the peak's workers. */
const EVENTS: ['s' | 'i' | 'e' | 'p', number, number][] = [
  ['s', 88, 0], ['e', 99, 0], ['e', 99, 0], ['i', 189, 0], ['i', 189, 0], ['i', 189, 0], ['i', 189, 0], ['i',
  189, 0], ['i', 189, 0], ['i', 189, 0], ['i', 189, 0], ['i', 189, 0], ['i', 189, 0], ['p', 242, 25], ['s', 329,
  0], ['s', 512, 0], ['e', 713, 0], ['e', 713, 0], ['e', 822, 0], ['s', 1004, 0], ['s', 1004, 0], ['e', 1004,
  0], ['e', 1090, 0], ['e', 1090, 0], ['s', 1312, 0], ['e', 1313, 0], ['e', 1313, 0], ['e', 1313, 0]
];

const TZ = 'America/New_York';
const START = Date.parse('2026-10-19T04:00:00.000Z');
const at = (minute: number) => new Date(START + minute * 60_000).toISOString();

function event([kind, minute, extra]: (typeof EVENTS)[number]): IReplayEvent {
  const base = { at: at(minute) };
  if (kind === 's') return { ...base, kind: 'safety', eventId: `s${minute}`, floorId: null, isCritical: extra === 1, typeKey: 'sos', trade: null };
  if (kind === 'i') return { ...base, kind: 'issueOpened', floorId: null, issueId: `i${minute}` };
  if (kind === 'e') return { ...base, kind: 'equipmentMoved', equipmentId: 'e', fromFloorId: 'a', toFloorId: 'b' };
  return { ...base, kind: 'peak', workers: extra, floors: 1 };
}

/** A generic site day, as the replay endpoint returns one. */
export const SKELETON_DAY: IMonitorReplay = {
  date: '2026-10-19',
  timezone: TZ,
  frames: FRAMES.map(([minute, workers]) => ({ t: at(minute), workers, floors: {} })),
  gaps: GAPS.map(([from, to]) => ({ from: at(from), to: at(to) })),
  firstIn: at(25),
  lastOut: at(1398),
  intervalMs: 30_000,
  window: { start: at(0), end: at(1440) },
  dataEnd: at(1440),
  equipment: {},
  events: EVENTS.map(event),
};

